import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { DrugService } from 'src/app/services/drug.service';
import { CNDrug } from 'src/app/models/cndrug';
import { CNDrugIngredient } from 'src/app/models/cndrugingredient';
import { SNItemTableControl, SNItemTableService, SNItemTableServiceCapability } from 'src/app/snitem-table/snitem-table-interface';
import { CNDrugPackage } from 'src/app/models/cndrugpackage';



@ManageType('DrugComponent')
@Component({
  selector: 'app-drug',
  templateUrl: './drug.component.html',
  styleUrls: ['./drug.component.scss']
})
export class DrugComponent implements OnInit, SNItemTableService {

  public data = new BehaviorSubject<CNDrugPackage[]>([]);

  constructor(private drug: DrugService) { }

  drugSearchControl = new UntypedFormControl();
  filteredDrugs: Subject<CNDrug[]>;
  selectedDrug: CNDrug | CNDrugIngredient;

  ngOnInit(): void {
    this.filteredDrugs = new Subject<CNDrug[]>();
    this.drugSearchControl.valueChanges.subscribe(value => {
      this.drug.search(value).subscribe(drugs => {
        this.filteredDrugs.next(drugs);
      });
    });
  }

  selectDrug(drug: CNDrug | CNDrugIngredient) {
    this.selectedDrug = drug;
    // Get all packages
    this.drug.packages(drug).subscribe(packages => {
      this.data.next(packages);
    });
  }

  /**
   * snitem table service
   */

  addItem(item: CNDrug) {
  }

  snRegisterControl(control: SNItemTableControl) {
    console.log('register control');
  }

  snCapabilities(): SNItemTableServiceCapability[] {
    return [SNItemTableServiceCapability.search];
  }

  get fields() {
    return [];
  }

  store() { }

  send() { }

}
